<template>
  <div id="app">
    <router-view />
    <TrackingPixel v-if="showPixel && !isStaff" />
    <div class="terms-wrapper">
      <Terms />
    </div>
    <!-- <InitialSurvey /> -->

    <WidgetScript />
  </div>
</template>

<script lang="ts">
import { defineComponent, watch, ref, onMounted, computed } from 'vue'
import TrackingPixel from '@/components/TrackingPixel.vue'
import WidgetScript from '@/components/WidgetScript.vue'
import { useUserStore } from '@/store/modules/user'
import { provideLogo } from '@/hooks/useLogo'
import { provideConfig } from '@/hooks/useConfig'
import Terms from '@/components/Terms/index.vue'
// import InitialSurvey from '@/components/InitialSurvey.vue'
import useRouter from '@/hooks/useRouter'
import { darkTheme } from '@/utils/helpers'

export default defineComponent({
  name: 'App',
  components: {
    TrackingPixel,
    WidgetScript,
    Terms
    // InitialSurvey
  },
  setup() {
    const userStore = useUserStore()
    const { isStaff } = userStore
    const userID = computed(() => userStore.userID)

    // Providing values using the Composition API
    provideLogo('traforama')
    provideConfig('traforama')

    // Reactive state for showPixel
    const showPixel = ref(Number(userID.value) > 0)

    // Using the custom useRouter hook to access route
    const { route } = useRouter()

    // Watchers to update showPixel based on changes in userID and route
    watch(userID, (newValue: any) => {
      if (newValue) {
        showPixel.value = true
      }
    })

    watch(route.value, (newValue: any) => {
      if (newValue.meta?.auth) {
        showPixel.value = true
      }
    })

    // Add dark theme class when component is mounted
    onMounted(() => {
      if (darkTheme) {
        document.documentElement.classList.add(darkTheme)
      }
    })

    return { isStaff, showPixel }
  }
})
</script>

<style lang="scss" scoped>
.terms-wrapper {
  position: relative;
  z-index: 4000;
}
</style>
